import $ from 'jquery';
import { settingObj } from './SettingSlice';


let FlagDic = {
    navFlag: 0,
};

export function setViewHidden(isBlack) {
    if (isBlack && FlagDic.navFlag == 0) {
        $("#home_page_left_view").fadeIn('fast', () => { });
        $("#home_page_right_view").fadeIn('fast', () => { });
        $("#subscript_view").fadeIn('fast', () => { });
        FlagDic.navFlag = 1;
    } else if (!isBlack && FlagDic.navFlag == 1) {
        $("#home_page_left_view").fadeOut('fast', () => { });
        $("#home_page_right_view").fadeOut('fast', () => { });
        $("#subscript_view").fadeOut('fast', () => { });
        FlagDic.navFlag = 0;
    }
}

export function scrollToTop(pageId) {
    $("#" + pageId).animate({
        scrollTop: 0,
    }, "slow");
}

export function scrollToView(viewId) {
    $("#home_page_view").animate({
        scrollTop: $(`#${viewId}`).offset().top + $(`#home_page_view`).scrollTop() //- $("#nav_view").height()
    }, "slow");
}

export function isShowing(elId) {
    try {
        if (elId == null || elId == undefined || elId == '') {
            return false;
        }

        let el = $('#' + elId)[0];
        if (el) {
            let h = $(window).height();
            let top = el.getBoundingClientRect().top;
            return top < (h - 50) && top > -el.offsetHeight;
        } else {
            return false;
        }
    } catch (e) {
        console.log(e);
        return false;
    }
}

export function isFirstShowing(elId) {
    if (elId == null || elId == undefined || elId == '') {
        return false;
    }
    if ($('#' + elId).hasClass('first_showing_class')) {
        return false;
    }
    if (isShowing(elId)) {
        $('#' + elId).addClass('first_showing_class');
        return true;
    };
    return false;
}



export function isEmpty(str) {
    if (str === null || str === undefined || !str || str === "" || 'undefined' === str || 'null' === str) {
        return true;
    }
    return false;
}

export function isEmail(str) {
    if (isEmpty(str) || str.length < 4 || str.length > 100) {
        return false;
    }
    return str.match('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}');
}

export function saveLocalString(key, value) {
    if (typeof window !== 'undefined') {
        if (value == null) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }
    }
}

export function saveSessionString(key, value) {
    if (typeof window !== 'undefined') {
        sessionStorage.setItem(key, value);
    }
}

export function getLocalString(key) {
    if (typeof window !== 'undefined') {
        const str = localStorage.getItem(key);
        if (isEmpty(str)) {
            return "";
        }
        return str;
    } else {
        return "";
    }
}

export function getSessionString(key) {
    if (typeof window !== 'undefined') {
        const str = sessionStorage.getItem(key);
        if (isEmpty(str)) {
            return "";
        }
        return str;
    } else {
        return "";
    }
}

export function removeLocalString(key) {
    if (typeof window !== 'undefined') {
        localStorage.removeItem(key);
    }
}

export function clearLocalString() {
    if (typeof window !== 'undefined') {
        localStorage.clear();
    }
}

let os = function () {
    let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
}();

export let isMobile = function isMobile() {
    if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        return true;
    }
    return false;
}();

export let isAndroid = function () {
    if (os.isAndroid || (navigator.userAgent.toLowerCase().indexOf("android") !== -1)) {
        return true;
    }
    return false;
}();

export let isIOS = function () {
    let str = navigator.userAgent.toLowerCase();
    if (os.isPhone || (str.indexOf("iphone") !== -1) || str.indexOf("ipad") !== -1) {
        return true;
    }
    return false;
}();

export function uuid(num) {
    let x = num;
    if (x == null || x == undefined || x < 1) {
        x = 32;
    }
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < x) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}


export function getImgPath(name) {
    if (isEmpty(name)) {
        return '';
    }
    if (name.indexOf('game-cdn.aplusjapan-game.com') != -1) {
        return name;
    }
    if (name.indexOf('http') != -1) {
        return name;
    }

    return 'https://game-cdn.aplusjapan-game.com/thousand_web/images/' + name;
}

export let RoleAry = [{
    name: 'yetannia',
    nick: 'Faithbringer',
    info: 'As was one of history\'s most famed humans, her prophetic status led to her deification in later accounts. Her influence was experienced by many races, including the Velarra, Nuheillu, and Orccodro.'
}, {
    name: 'danni',
    nick: 'Monarch',
    info: 'As the last monarch of the Dividraggon Kingdom, she embodies the ultimate legacy of her ancestors. She is a proud descendant of the Divine Dragon, knowing her destiny was set at birth. She dedicates herself fully to creating a Divine Kingdom in the mortal world.'
}, {
    name: 'kelsuna',
    nick: 'Dawnborn',
    info: 'She began as an orphaned forest elf but came to serve the Elf Queen by chance. She read a lot and became a master in magical constructs over the centuries. From the Sacred Dragon War to the Rise of Torah, this timid elf witnessed numerous historical events.'
}, {
    name: 'giratia',
    nick: 'Vassal',
    info: 'As the daughter of the Red Dragon Princess Alexia, she is a rare single-child dragon who inherited all her mother\'s might. As she grew, she became a symbol of mortal strength at its peak.'
}, {
    name: 'cecily',
    nick: 'Earthborn',
    info: 'During the Ancient War, Cecily, a noble of the Seramo Kingdom, was personally guided by Jancis to become the first human-turned-angel. As a pivotal figure of the Era of Rebirth, "Dawnbreaker" significantly impacted the subsequent history of Mirren.'
}, {
    name: 'penelope',
    nick: 'Tormentra',
    info: 'She is a stylish sorceress with a cute appearance but an incredibly lazy personality. She seldom speaks to others, yet often talks to a doll named "Odysseus". This doll contains the sorceress\' heart.'
}, {
    name: 'sarah',
    nick: 'Divinita',
    info: 'A steadfast and devoted Valkyrie who ushers in valiant spirits from the mortal realm to the Heavenly Realm. She forges the Heavenly Army and commands the legions in conquest of neighboring star sectors under Sarah\'s leadership. She has spent her entire life, from initial resolution to later bewilderment, on this long interAster journey.'
}];

export function capitalize(string) {
    if (isEmpty(string)) {
        return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function googleTap() {
    const ad = settingObj.platform;
    let url = 'https://play.google.com/store/apps/details?id=com.crunchyroll.crg.mirren';

    if ('fbpreg' == ad) {
        window.fbq('track', 'msl_crg_android_fbpreg'); //FB埋点

    } else if ('ttpreg' == ad) {
        window.tt_event('ClickButton', 'mol_crg_android_ttpreg'); //TT埋点

    } else if ('ggpreg' == ad) {
        window.gtag('event', 'msl_crg_android_ggpre'); //GG埋点
        window.gg_ad_conversion('wM-cCP_wr7waEMaakr8B'); //GG广告
    }else{
        url = "https://msl.sng.link/Dfteh/4tib/o18d";
        window.fbq('track', 'msl_crg_android_'); 
        window.gtag('event', 'msl_crg_android_'); 
        window.tt_event('msl_crg_android_ttpreg', 'msl_crg_android_ttpreg'); 
    }

    window.open(url);
}

export function appleTap() {
    const ad = settingObj.platform;
    let url = 'https://apps.apple.com/us/app/mirren-star-legends/id6740132784';
    if ('fbpreg' == ad) {
        window.fbq('track', 'msl_crg_ios_fbpreg'); //FB埋点
        url= 'https://apps.apple.com/us/app/mirren-star-legends/id6740132784?ppid=255c3042-5d15-4a70-9b8e-6b41e882108b'

    } else if ('ttpreg' == ad) {
        window.tt_event('ClickButton', 'mol_crg_ios_ttpreg'); //TT埋点
        url = 'https://apps.apple.com/us/app/mirren-star-legends/id6740132784?ppid=d3b9ab6e-66d0-457a-85cb-b35bfd522c73'

    } else if ('ggpreg' == ad) {
        window.gtag('event', 'msl_crg_ios_ggpre'); //GG埋点
        window.gg_ad_conversion('V_53CPzwr7waEMaakr8B'); //GG广告
        url = 'https://apps.apple.com/us/app/mirren-star-legends/id6740132784?ppid=fa4f4dac-1ad9-42cc-9250-1950ddc40d1c'
  
    }else{
        url = "https://msl.sng.link/Dfteh/knq3/kkdh";
        window.fbq('track', 'msl_crg_ios_'); 
        window.gtag('event', 'msl_crg_ios_'); 
        window.tt_event('msl_crg_ios_ttpreg', 'msl_crg_ios_ttpreg'); 
    }
    window.open(url);
}

export function twitterTap() {
    window.open('https://x.com/MirrenSL');
    trackEvent('twitter_tap');
}

export function discordTap() {
    window.open('https://discord.gg/cSsYwGkPFr');
    trackEvent('discord_tap');
}

export function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export function isVerifyCode(str) {
    if (isEmpty(str)) {
        return false;
    }
    return str.match('[0-9]{6}');
}

export function trackEvent(name) {
    console.log('trackEvent: ', name);
    window.gtag('event', name); //GG埋点
}

export function isCR() {
    if (window.location.href.indexOf('mirrenstarlegends.com') != -1) {
        return true;
    }
    return false;
}
